export default __webpack_public_path__ + "static/media/day.69de5fde.svg";